import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, Typography, CircularProgress, Grid } from "@material-ui/core";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import Container from "@material-ui/core/Container";
import { Trans, useTranslation } from "react-i18next";
import { GetApp, Publish } from "@material-ui/icons";
import { useLocation } from "react-router";
import { get } from "@totalsoft/react-state-lens";

const useStyles = makeStyles(publicMainStyle);

const PublicHeader = (props) => {
  const { stateLens, transactionId, givenName, familyName, email, phoneNumber, tokenExpired } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { logo } = useTheme();
  const { pathname } = useLocation();
  const isDataCompletion = pathname.includes("data-completion");
  const isGdprConsent = pathname.includes("gdpr-consent");

  return (
    <Container maxWidth="md" className={classes.publicHeaderFooterGrid}>
      <div className={classes.logoWrapper}>
        <img src={logo} alt="logo" className={classes.wrappedImg} />
      </div>
      {isGdprConsent && (
        <>
          {(stateLens.loading |> get) && (
            <Grid container alignItems="center" direction="row" spacing={3}>
              <Grid item>
                <Typography variant="caption" component="div" className={classes.note}>
                  <CircularProgress size={20} color={"primary"} />
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="caption" component="div" className={classes.note}>
                  {t("PublicInfo.GdprConsentLoadingMessage")}
                </Typography>
              </Grid>
            </Grid>
          )}
          {!(stateLens.loading |> get) && (
            <Typography variant="caption" component="div" className={classes.note}>
              {tokenExpired ? t("PublicInfo.GdprUrlDeactivated") : t("PublicInfo.GdprUrlActivatedWithinTenDays")}
            </Typography>
          )}
        </>
      )}
      {!isGdprConsent && (
        <>
          <Typography variant="subtitle1" component="div" className={classes.title}>
            {isDataCompletion ? t("PublicInfo.DocumentUpload") : t("PublicInfo.SignedDocumentUpload")}
          </Typography>

          <Typography variant="subtitle2" component="div" className={classes.subtitle}>
            {t("PublicInfo.DearCustomer")}
          </Typography>

          <Typography variant="caption" component="div">
            {t("PublicInfo.Contact", {
              transactionId: transactionId,
              name: `${givenName} ${familyName}`,
              phone: phoneNumber ?? "-",
              email: email ?? "-",
            })}
          </Typography>
          <Typography variant="caption" component="div" className={classes.paddingTopBottom10}>
            {isDataCompletion ? t("PublicInfo.ListedRequiredDocuments") : t("PublicInfo.ListedContractualDocuments")}
          </Typography>
          <Typography variant="caption" component="div" className={classes.paddingTopBottom10}>
            <Trans i18nKey="PublicInfo.SelectAddFiles" components={<Publish color="primary" fontSize="small" />} />
          </Typography>
          <Typography variant="caption" component="div">
            <Trans i18nKey="PublicInfo.SelectDownloadFiles" components={<GetApp color="action" fontSize="small" />} />
          </Typography>
          <Typography variant="caption" component="div" className={classes.note}>
            {t("PublicInfo.NoteOriginalsMustBeSent")}
          </Typography>
        </>
      )}
    </Container>
  );
};

PublicHeader.propTypes = {
  stateLens: PropTypes.object.isRequired,
  transactionId: PropTypes.string,
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  tokenExpired: PropTypes.bool,
};

export default PublicHeader;
